import React from "react";
import "./getAQuote.scss";
import { BiLogoFacebook, BiLogoTwitter } from "react-icons/bi";
import { AiFillInstagram } from "react-icons/ai";
import { Link } from "react-router-dom";
import quoteBg from '../../assets/getaqoute/get-a-qoute-form-bg.png'
import quoteheroBg from '../../assets/getaqoute/get-a-qoute-bg.png'
import Button from "../Common/Button/Button";

const GetAQuote = () => {
  return (
    <>
      <section id="get-quote">
        <section id="get-a-quote-wrapper">
          <div className="hero-wrapper">
            <div className="get-content">
              <h2>Get a Quote</h2>
              <span>
                <Link>Home</Link> | <Link>Get a Quote</Link>
              </span>
            </div>
            <div className="followus">
              <div className="follow-us">
                <p>Follow us</p>
                <div></div>
                <AiFillInstagram />
                <BiLogoTwitter />
                <BiLogoFacebook />
              </div>
            </div>
          </div>
        </section>
        <div className="specialties-btn">
          <Button id="arrow-wrapper-right">Specialties</Button>
        </div>
        <section id="get-a-qoute-form-wrapper">
            <img src={quoteBg} alt="" />
          <div className="get-a-qoute-form">
            <div className="get-touch">
              <h1>
                Get in Touch With Us And <span>We’ll Help You</span>
              </h1>
            </div>

            <div className="form-quote">
                <div className="text-info">
                <p>Personal information*</p>
                </div>
              <form action="">
                <div className="row">
                  <div className="col-md-6">
                    {" "}
                    <label>Name*</label>
                    <input type="text" name="" id="" placeholder="First name" />
                  </div>
                  <div className="col-md-6">
                    <label className="hide">Last Name</label>
                    <input type="text" name="" id="" placeholder="Last name" />
                  </div>
                  <div className="col-md-6">
                    <label>Email*</label>
                    <input type="text" name="" id="" placeholder="Your Email" />
                  </div>
                  <div className="col-md-6">
                    <label>Phone*</label>
                    <input type="text" name="" id="" placeholder="Your Phone" />
                  </div>
                  <div className="col-md-6">
                    <label>What would you like a quote for?*</label>
                    <input type="text" name="" id="" placeholder="First name" />
                  </div>
                  <div className="col-md-6">
                    <label>Where did you hear about us?*</label>
                    <input type="text" name="" id="" placeholder="First name" />
                  </div>
                  <div className="col-md-12">
                    <label>Message</label>
                    <textarea
                      placeholder="Your Message...."
                      rows={6}
                    ></textarea>
                  </div>
                  <div className="col-md-12">
                    <Button id="arrow-wrapper-right">Request a Quote</Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default GetAQuote;
